<template>
  <div
    class="basic_development_history"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    @dblclick="changeStyle('style')"
  >
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_index_336')"
        btnIcon="el-icon-edit"
        @changeStyle="changeStyle('style')"
      ></my_hover_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_hover_btn
          :tips="$t('widgets_basic_article_classification_edit_330')"
          btnIcon="el-icon-magic-stick"
          @changeStyle="changeStyle('animation')"
        ></my_hover_btn>
        <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
        ></my_close_btn>
      </template>
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <div :class="`history_${listArr.module_style}`" class="history" v-if="listArr.module_style == 0">
      <div class="container">
        <div class="title wb-normal" v-html="listArr.richTextTitle"></div>
        <div class="jsh">
          <ul>
            <li
              v-for="(item, i) in listArr.list"
              :key="i"
              :style="[backgroundStyle]"
            >
              <set_link class="linkPart" :sendData="item.link"></set_link>
              <div class="li_content">
                <div class="left">
                  <span class="wb-normal" :style="titleFontStyle">{{ item.title }}</span>
                  <span class="left1"></span>
                </div>
                <div class="right1">
                  <p class="wb-normal" v-html="item.summary"></p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div :class="`history_${listArr.module_style}`" v-if="listArr.module_style == 1">
      <div class="container">
        <div class="home-title wb-normal" v-html="listArr.richTextTitle"></div>
        <div class="bottom">
          <div class="list">
            <ul>
              <li
                class="clearfix"
                v-for="(item, i) in listArr.list"
                :key="i"
                :class="i % 2 !== 0 ? 'odd' : 'even'"
              >
                <set_link class="linkPart" :sendData="item.link"></set_link>
                <div class="box">
                  <div class="text" :style="[backgroundStyle]">
                    <div class="bt wb-normal" :style="titleFontStyle">
                      {{ item.title }}
                    </div>
                    <div class="jsh1">
                      <p class="jsh1_content wb-normal" v-html="item.summary"></p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="more">
              <a href="#"
                ><img
                  src="https://sitecdn.71360.com/static/txys-001/image/history/more3.png"
                  alt=""
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="listArr.module_style == 2"
      :class="`history_${listArr.module_style}`"
    >
      <div class="history-title" v-html="listArr.richTextTitle"></div>
      <div class="in-bottom">
        <div class="history_ul">
          <button
            type="button"
            @click="swiper_prev"
            data-role="none"
            class="slick-prev slick-arrow"
            aria-label="Previous"
            role="button"
            style="display: block"
          >
            Previous
          </button>
          <swiper
            :key="listArr.is_loop"
            ref="mySwiper"
            :options="swiperOption"
            v-if="$store.state.app.basic_development_history_isRender"
          >
            <swiper-slide
              v-for="(item, i) in listArr.list"
              :key="i"
              class="history_li"
            >
              <set_link class="linkPart" :sendData="item.link"></set_link>
              <div class="box" :style="[backgroundStyle]">
                <div class="date">
                  <p :style="titleFontStyle">{{ item.title }}</p>
                </div>
                <div class="jsh" v-html="item.summary"></div>
              </div>
            </swiper-slide>
          </swiper>
          <button
            type="button"
            @click="swiper_next"
            data-role="none"
            class="slick-next slick-arrow"
            aria-label="Next"
            role="button"
            style="display: block"
          >
            Next
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="listArr.module_style == 3"
      :class="`history_${listArr.module_style}`"
    >
      <div class="history-title" v-html="listArr.richTextTitle"></div>
      <div class="history-bottom">
        <div class="history_ul">
          <button
            type="button"
            @click="swiper_prev"
            data-role="none"
            class="slick-prev slick-arrow"
            aria-label="Previous"
            role="button"
            aria-disabled="false"
            style="display: block"
          >
            Previous
          </button>
          <swiper
            :key="listArr.is_loop"
            ref="mySwiper"
            :options="swiperOption"
            v-if="$store.state.app.basic_development_history_isRender"
          >
            <swiper-slide
              v-for="(item, i) in listArr.list"
              :key="i"
              class="history_li"
            >
              <div class="box" :style="[backgroundStyle]" @click="goLink">
                <template v-if="$store.state.app.view_pattern === 'mb'">
                  <div class="nr">
                    <div class="year" :style="titleFontStyle">
                      {{ item.title }}
                    </div>
                    <div class="anr" v-html="item.summary"></div>
                  </div>
                  <div class="title"></div>
                </template>
                <template
                  v-if="i % 2 == 0 && $store.state.app.view_pattern === 'pc'"
                >
                  <div class="nr">
                    <div class="year" :style="titleFontStyle">
                      {{ item.title }}
                    </div>
                    <div class="anr" v-html="item.summary"></div>
                  </div>
                  <div class="title"></div>
                </template>
                <template
                  v-if="i % 2 !== 0 && $store.state.app.view_pattern === 'pc'"
                >
                  <div class="title"></div>
                  <div class="nr">
                    <div class="anr" v-html="item.summary"></div>
                    <div class="year" :style="titleFontStyle">
                      {{ item.title }}
                    </div>
                  </div>
                </template>
              </div>
            </swiper-slide>
          </swiper>
          <button
            type="button"
            @click="swiper_next"
            data-role="none"
            class="slick-next slick-arrow slick-disabled"
            aria-label="Next"
            role="button"
            style="display: block"
            aria-disabled="true"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "basic_development_history",
  data () {
    return {
      isHover: false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    goLink() {
      this.$message.warning(i18n.t('widgets_basic_development_history_index_499'))
    },
    module_isHover (val) {
      this.isHover = val
    },
    changeStyle (tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    swiper_prev () {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    swiper_next () {
      this.$refs.mySwiper.swiper.slideNext();
    },
  },
  watch: {
    'infor': {
      handler: function (val, oldVal) {
        // this.swiperNumber = this.$store.state.app.view_pattern === 'pc' ? parseInt(val.col_num[val.col_num.radio_val].value) : 1
        this.templet.all_banner_render("basic_development_history");
      },
      deep: true
    },
    'listArr.list': {
      handler: function (val, oldVal) {
        this.templet.all_banner_render("basic_development_history");
      },
      deep: true
    },
    '$store.state.app.view_pattern'(val) {
      // const infor = this.module.data.pc_widgets_infor;
      // this.swiperNumber = val === 'pc' ? parseInt(infor.col_num[infor.col_num.radio_val].value) : 1
      this.templet.all_banner_render("basic_development_history");
    }
  },
  computed: {
    swiperNumber() {
      const infor = this.module.data.pc_widgets_infor;
      return this.$store.state.app.view_pattern === 'pc' ? parseInt(infor.col_num[infor.col_num.radio_val].value) : 1
    },
    swiperOption () {
      const infor = this.module.data.pc_widgets_infor;
      const swiperNumber =  this.$store.state.app.view_pattern === 'pc' ? parseInt(infor.col_num[infor.col_num.radio_val].value) : 1
      const obj = {
        myVm: this,
        loop: this.listArr.is_loop !== 'default',
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        speed: 500,
        direction: "horizontal",
        simulateTouch: false,
        observer: true,
        observeParents: true,
        slidesPerView: swiperNumber,
        slidesPerGroup: 1
      };
      return obj;
    },
    infor () {
      return this.module.data.pc_widgets_infor;
    },
    widgets_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    listArr () {
      return this.module.data.listArr;
    },
    titleFontStyle () {
      let pc_infor = this.module.data.pc_widgets_infor
      let fontStyle = {}
      let font = pc_infor.titleFont[pc_infor.titleFont.radio_val]
      fontStyle.fontSize = font.fontSize + 'px'
      fontStyle.fontFamily = font.fontFamily
      fontStyle.fontWeight = font.fontWeight
      fontStyle.fontStyle = font.fontItalics
      fontStyle.textDecoration = font.fontUnderline

      if (font.pattern == 'linear_gradient') {
        fontStyle.webkitBackgroundClip = 'text'
        fontStyle.webkitTextFillColor = 'transparent'
        fontStyle.color = ''
        fontStyle.backgroundImage = 'linear-gradient(' + font.linear_gradient.deg + 'deg,' + font.linear_gradient.start_color +
          font.linear_gradient.start_pointer + '%,' + font.linear_gradient.end_color + font.linear_gradient.end_pointer +
          '%)'
      } else {
        fontStyle.color = font.fontColor
      }
      return fontStyle
    },
    backgroundStyle () {
      let infor = this.module.data.pc_widgets_infor
      return {
        backgroundColor: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.color : '',
        backgroundImage: infor.set_style.background.radio_val == 'custom' && infor.set_style.background.custom.img !== '' ? 'url(' + infor.set_style.background.custom.img + ')' : '',
        backgroundSize: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_size : '',
        backgroundRepeat: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_repeat : '',
        backgroundPosition: infor.set_style.background.radio_val == 'custom' ? infor.set_style.background.custom.background_position : ''
      }
    }
  },
  created () {
  }
};
</script>

<style scoped lang="scss">
.basic_development_history .history_0 {
  margin-bottom: 31px;
  overflow: hidden;
  padding-top: 30px;
  .title {
    color: #333;
    line-height: 28px;
    margin-bottom: 13px;
  }
  .container {
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }
  ul {
    margin-top: 41px;
    padding-top: 30px;
    overflow: hidden;
    position: relative;
    &:before {
      content: "";
      display: block;
      width: 24px;
      height: 20px;
      position: absolute;
      top: 0;
      left: 88px;
      background: url("https://sitecdn.71360.com/static/txys-001/image/history/top.png")
        no-repeat top center;
      z-index: 2;
    }
    &:after {
      content: "";
      display: block;
      width: 2px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 100px;
      background: #e9e9e9;
      z-index: 1;
    }
    li {
      position: relative;
      overflow: hidden;
      margin: 0 0px 40px 0px;
      .li_content {
        display: flex;
      }
      .left{
        width: 100px;
        padding: 15px;
        word-wrap: break-word;
      }
      .left1 {
        position: absolute;
        top: 0;
        left: 5px;
        height: 30px;
        width: 100px;
        z-index: 4;
        background: url("https://sitecdn.71360.com/static/txys-001/image/history/dot09.png")
          no-repeat center right;
      }
      .right1 {
        font-size: 14px;
        color: #333;
        line-height: 24px;
        padding-left: 40px;
        padding: 15px;
        flex: 1;
      }
    }
  }
}
.mb_pattern .basic_development_history {
  .history_0 ul li .right1 {
    padding-left: 30px;
  }
  .history_0 ul li {
    margin-bottom: 20px;
  }
}
// 第2种
.basic_development_history .history_1 {
  padding: 61px 0 100px 0;
  overflow: hidden;
  .container {
    width: 100%;
    .home-title {
      position: relative;
      padding-top: 5px;
      text-align: center;
    }
  }
  .bottom {
    text-align: center;
    padding-top: 15px;
    overflow: hidden;
    ul {
      padding-bottom: 20px;
      position: relative;
      &:after {
        content: "";
        display: block;
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 50%;
        background: #ccdded;
        margin-left: -0.5px;
      }
      li {
        .box {
          position: relative;
        }
        .text {
          width: 50%;
          padding-right: 15px;
          padding-top: 15px;
        }
        .bt {
          margin-bottom: 20px;
        }
        .jsh1 {
          line-height: 24px;
          font-size: 16px;
          text-align: left;
          .jsh1_content {
            background: url(https://sitecdn.71360.com/static/txys-001/image/history/dot1.png)
              no-repeat left 11px;
            margin-bottom: 18px;
          }
        }
      }
      .even {
        .text {
          float: right;
          .bt {
            text-align: left;
            background: url(https://sitecdn.71360.com/static/txys-001/image/history/bleft.png)
              no-repeat center left;
            padding-left: 110px;
            width: 100%;
            word-wrap:break-word;
          }
          .jsh1 {
            padding-left: 80px;
            .jsh1_content {
              padding-left: 30px;
            }
          }
        }
      }
      .odd {
        .text {
          float: left;
          padding-left: 15px;
          padding-right: 0;
          .bt {
            text-align: right;
            background: url(https://sitecdn.71360.com/static/txys-001/image/history/bright.png)
              no-repeat center right;
              padding-right: 110px;
          }
          .jsh1 {
            text-align: right;
            margin-right: 80px;
            .jsh1_content {
              background: url(https://sitecdn.71360.com/static/txys-001/image/history/dot1.png)
                no-repeat right 11px;
              width: 100%;
              box-sizing: border-box;
              padding-right: 30px;
            }
          }
        }
      }
    }
    .more {
      width: 103px;
      height: 103px;
      margin: 0 auto;
      a {
        display: block;
      }
    }
  }
}
.mb_pattern .basic_development_history .history_1{
  ul {
    &:after {
      left: 15px;
      margin-left: 0;
    }
    .more {
      width: 32px;
      height: 32px;
      margin: 0;
    }
    li {
      .box {
        margin-left: -66px;
        .text {
          float: none !important;
          padding-top: 15px !important;
          padding-right: 0px !important;
          width: 100%;
        }
      }
      .bt {
        z-index: 2;
        position: relative;
        padding: 0 0 0 105px !important;
      }
      .jsh1 {
        font-size: 14px;
        margin-left: 100px;
        padding: 0 !important;
        margin-right: 0 !important;
        .jsh1_content {
          padding-bottom: 10px;
          padding-right: 15px !important;
          padding-left: 5px !important;
          background: none !important;
          text-align: left;
        }
      }
    }
    .even {
      .text {
        .bt {
          padding: 0 0 0 105px !important;
          .jsh1 {
            padding: 0 15px 15px 80px;
            .jsh1_content {
              padding-left: 20px;
            }
          }
        }
      }
    }
    .odd {
      .text {
        .bt {
          text-align: left;
          background: url(https://sitecdn.71360.com/static/txys-001/image/history/bleft.png)
            no-repeat center left;
          padding-left: 100px;
          margin-left: -15px;
        }
        .jsh1 {
          text-align: left;
          margin-right: 0;
          margin-left: 80px !important;
          .jsh1_content {
            background: url(https://sitecdn.71360.com/static/txys-001/image/history/dot1.png)
            no-repeat left 11px;
            padding-left: 20px;
            margin-left: 0px;
            padding-right: 15px;
          }
        }
      }
    }
  }
}
// 第三种样式
.history_2 {
  padding: 30px 0;
  overflow: hidden;
  .in-title {
    text-align: center;
  }
  .in-bottom {
    margin-top: 65px;
    position: relative;
    overflow: hidden;
    .history_ul {
      position: relative;
      z-index: 3;
      padding-bottom: 104px;
      .box {
        position: relative;
        padding: 0 10px 0 15px;
        height: 100%;
        text-align: left;
        &:after {
          content: "";
          display: block;
          height: 1px;
          width: 100%;
          background: #e5e5e5;
          position: absolute;
          top: 25px;
          left: 0;
          z-index: 1;
        }
        .date {
          background: url("https://sitecdn.71360.com/static/txys-001/image/history/hh.png")
            no-repeat top center;
          display: inline-block;
          font-size: 15px;
          color: #777;
          padding-top: 40px;
          font-family: arial;
          margin-bottom: 29px;
          width: 100%;
          position: relative;
          z-index: 3;
          margin-top: 15px;
        }
        .jsh {
          font-size: 15px;
          color: #555;
          line-height: 25px;
          overflow: hidden;
          margin-bottom: 57px;
        }
      }
    }
  }
  /deep/ .swiper-slide {
    height: auto !important;
  }
}
.mb_pattern .history_2 .container {
  margin-right: auto;
  margin-left: auto;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}
.mb_pattern .history_2 .in-bottom .history_ul .box{
  margin-left: 0;
}
.mb_pattern .history_2 .in-bottom {
  margin-top: 20px;
}
.mb_pattern .history_2 .in-bottom .history_ul {
  padding-bottom: 64px;
}
.mb_pattern .history_2 .in-bottom .history_ul .history_li .date,
.mb_pattern .history_2 .in-bottom .history_ul .box:hover .date {
  margin-bottom: 0;
  background: none;
  padding-top: 0;
  padding-bottom: 10px;
}
.mb_pattern .history_2 .in-bottom .history_ul .box:after {
  display: none !important;
}
.mb_pattern .history_2 .in-bottom .history_ul .history_li .jsh {
  font-size: 14px;
  margin-bottom: 0;
}
.history_2 .in-bottom .history_ul .box:hover .date {
  background: url("https://sitecdn.71360.com/static/txys-001/image/history/h.png")
    no-repeat top center;
}
.history_2 .in-bottom .slick-prev,
.history_2 .in-bottom .slick-next {
  top: auto;
  bottom: 0;
  width: 44px;
  height: 44px;
  z-index: 3;
  font-size: 0;
  line-height: 0;
  margin-top: -10px;
  padding: 0;
  position: absolute;
  cursor: pointer;
  color: transparent;
  border: none;
  outline: none;
}
.history_2 .in-bottom .slick-prev {
  left: 50%;
  margin-left: -60px;
  background: url("https://sitecdn.71360.com/static/txys-001/image/history/left3.png")
    no-repeat center center;
}
.history_2 .in-bottom .slick-prev:hover {
  background: url("https://sitecdn.71360.com/static/txys-001/image/history/left3h.png")
    no-repeat center center;
}
.history_2 .in-bottom .slick-next {
  right: 50%;
  margin-right: -60px;
  background: url("https://sitecdn.71360.com/static/txys-001/image/history/right3.png")
    no-repeat center center;
}
.history_2 .in-bottom .slick-next:hover {
  background: url("https://sitecdn.71360.com/static/txys-001/image/history/right3h.png")
    no-repeat center center;
}
.history_2 .in-bottom .slick-prev:before,
.history_2 .in-bottom .slick-next:before {
  content: "";
}
//第四种样式
.history_3 {
  padding: 30px 15px;
  text-align: center;
  background-color: rgba(156, 150, 150,0.5);
  .history-bottom {
    margin: 102px 0 0 0;
    overflow: hidden;
    position: relative;
    margin-top: 20px;
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.5);
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -21px;
      z-index: 1;
    }
    .history_ul {
      margin-top: 20px;
      padding: 0 40px;
      position: relative;
      z-index: 2;
      .slick-prev {
        background: #fff
          url(https://sitecdn.71360.com/static/txys-001/image/history/left2.png)
          no-repeat center center;
        left: 0;
        width: 30px;
        height: 30px;
        border: none;
        border-radius: 50%;
        margin-top: -44px;
        z-index: 66;
        font-size: 0;
        line-height: 0;
        position: absolute;
        top: 50%;
      }
      .slick-next {
        background: #fff
          url(https://sitecdn.71360.com/static/txys-001/image/history/right2.png)
          no-repeat center center;
        right: 0;
        width: 30px;
        height: 30px;
        border: none;
        border-radius: 50%;
        margin-top: -44px;
        z-index: 66;
        font-size: 0;
        line-height: 0;
        position: absolute;
        top: 50%;
      }
      /deep/ .swiper-slide {
        background-color: transparent !important;
      }
      .history_li {
        .box {
          padding-left: 15px;
          position: relative;
          transition: 0.5s;
          text-align: left;
          &:after {
            content: "";
            display: block;
            height: 240px;
            width: 27px;
            bottom: 30px;
            position: absolute;
            left: 0;
            background: url(https://sitecdn.71360.com/static/txys-001/image/history/line1.png)
              no-repeat bottom center;
          }
        }
        .nr {
          transition: 0.5s;
          padding: 15px 15px 15px 0;
          .year {
            font-size: 20px;
            color: #f39800;
            font-family: "AvantGardeITCbyBT-Medium";
            transition: 0.5s;
          }
          .anr {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.5);
            margin-bottom: 14px;
            height: 96px;
            line-height: 24px;
            overflow: auto;
          }
        }
        .title {
          padding-top: 30px;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          color: #fff;
          font-size: 18px;
          text-align: center;
          line-height: 58px;
          border: 6px solid #fff;
          background: #f39800;
          margin-left: 13px;
        }
        &:nth-child(2n) .box {
          margin-top: 164px !important;
        }
        &:nth-child(2n) .box:after {
          width: 30px;
          top: 30px;
          bottom: auto;
          background: url(https://sitecdn.71360.com/static/txys-001/image/history/line2.png)
            no-repeat bottom center !important;
        }
        &:nth-child(2n) .title {
          margin-bottom: 61px !important;
        }
      }
    }
  }
}
.pc_pattern .history_3 .history-bottom .history_ul .history_li:hover .box {
  margin-top: -15px !important;
  margin-bottom: 15px !important;
}
.pc_pattern .history_3 .box ::-webkit-scrollbar {
  width: 0 !important;
}
.pc_pattern
  .history_3
  .history-bottom
  .history_ul
  .history_li:nth-child(2n):hover
  .box {
  margin-top: 145px !important;
  margin-bottom: 15px !important;
}
.mb_pattern {
  .history_3 {
    background-size:cover;
    .history-bottom {
        .history_ul {
          margin: 0;
          .history_li {
            text-align: center;
            .box {
                &:after {
                  display: none;
                }
            }
            .year {
              margin-bottom: 15px;
            }
            .nr {
              margin-top: 70px;
            }
            .anr {
                font-size: 14px;
                margin-bottom: 0;
                height: auto;
            }
            .title {
              width: 55px;
              height: 55px;
              font-size: 14px;
              line-height: 43px;
              position: absolute;
              margin-top: -64px;
              left: 50%;
              top: 0;
              margin-left: -26px;
            }
          }
        }
    }
  }
  .history_3 .history-bottom .history_ul .history_li:nth-child(2n) .box {
      margin-top: 0 !important;
  }
  .history_3 .history-bottom .history_ul .history_li:nth-child(2n) .title {
      margin-bottom: 0
  }
  .history_3 .history-bottom .slick-prev,.history_3 .history-bottom .slick-next {
    margin-top: 17px;
    top: 0;
  }
  .history_3 .history-bottom:after {
      top: 0;
      margin-top: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_development_history/index.vue